export default {
  title: 'Prodotti stampati personalizzati',
  fields: {
    name: 'Nome',
    format: 'Tipo prodotto',
  },
  buttons: {
    upload_product: 'Avvia caricamento',
    preview: 'Anteprima',
    edit: 'Modifica',
  },
};
